import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/Button'

export function ForbiddenPage() {
  const navigate = useNavigate()
  return (
    <div className="mx-auto max-w-[520px] py-12">
      <h1 className="t-title-lg text-ink">Access denied</h1>
      <Button className="mt-8" onClick={() => navigate('/')}>
        Back
      </Button>
    </div>
  )
}
